// Sidebar.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  return (
    <aside className="sidebar">   
      <nav>
        <ul>
          <li><Link to="/appointments">Appointments</Link></li>
          <li><Link to="/users">Users</Link></li>
          <li><Link to="/askDoctor">Ask Doctor</Link></li>
          <li><Link to="/offers">Offers</Link></li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;